import { Instance, SnapshotOut, types } from 'mobx-state-tree';

import { withEnvironment } from '../extensions/withEnvironment';
import { withRootStore } from '../extensions/withRootStore';
import { createResponse, IResponse } from '../response/Response';

/**
 * # ResponseStore
 *
 * ResponseStore을 설명하세요.
 */
export const ResponseStore = types
  .model('ResponseStore')
  // --------------------------------------------------------------------------
  .props({
    responseInfo: createResponse(),
  })
  .extend(withEnvironment)
  .extend(withRootStore)
  .actions((self) => ({
    setResponseInfo: (responseInfo: IResponse) => {
      self.responseInfo = responseInfo;
    },
    errorProcessing: (error: any) => {
      console.log('errorProcessing', error);
      self.responseInfo.reset();
    },
    getErrorMessage: (defaultMessage = '오류가 발생했습니다.') => {
      const msg = self.responseInfo.errorMessage ?? '';
      return msg.length > 0 ? msg : defaultMessage;
    },
  }));

// --------------------------------------------------------------------------
type TResponseStore = Instance<typeof ResponseStore>;
type TResponseStoreSnapshot = SnapshotOut<typeof ResponseStore>;

export interface IResponseStore extends TResponseStore {}
export type TResponseStoreKeys = keyof TResponseStoreSnapshot & string;
export interface IResponseStoreSnapshot extends TResponseStoreSnapshot {}
export const createResponseStore = () => types.optional(ResponseStore, {} as TResponseStore);
